// extracted by mini-css-extract-plugin
module.exports = {"btn":"_2Aicafm17J-_5Wyg7Eom_y","reset":"_1bc-Hh-XxKH0WP_AO88AfO"};